/**
 * Empty state for the Governance Approver Inbox — rendered when the viewer
 * has no engagements awaiting their approval.
 *
 * Tone: brief, reassuring, not over-decorated. The empty state should feel
 * like an end-of-queue confirmation, not an error.
 */
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';

export default function EmptyState(): JSX.Element {
  return (
    <div
      className="flex flex-col items-center gap-8 rounded-lg border border-dashed border-surface-border bg-surface-elevated px-24 py-48 text-center"
      role="status"
    >
      <CheckCircleOutlined sx={{ fontSize: 40 }} className="text-brand-primary" />
      <h2 className="text-on-surface hd-5">All caught up</h2>
      <p className="text-on-surface-muted body-2">
        No engagements are awaiting your approval right now.
      </p>
    </div>
  );
}
